<input *ngIf="isLogin == 'true'" (change)="onInputChange($event)" placeholder="{{ placeholder }}" class="input"
  type="{{ type }}" />

<div *ngIf="isAdd == 'true'" class="input-container">
  <label class="input-label">{{ placeholder }}</label>
  <input [ngModel]="inputText" (change)="onInputChange($event)" class="add-input" type="text"
    [readonly]="isReadOnly$ | async" [ngStyle]="{ cursor: isView ? 'context-menu' : 'auto' }" />
</div>

<div *ngIf="isSlokaTypeTextArea == 'true'" class="input-container">
  <label class="input-label">{{ placeholder }}</label>
  <textarea [ngModel]="inputText" (change)="onInputChange($event)" class="sloka-type-text-area-input" type="text"
    [readonly]="isReadOnly$ | async"></textarea>
</div>

<div *ngIf="isSlokaTextArea == 'true'" class="input-container">
  <label class="input-label">{{ placeholder }}</label>
  <textarea [ngModel]="inputText" (change)="onInputChange($event)" class="sloka-text-area-input" type="text"
    [readonly]="isReadOnly$ | async"></textarea>
</div>

<div *ngIf="isUpload == 'true'" class="input-container">
  <label class="input-label">{{ placeholder }}</label>
  <input (change)="onInputChange($event)" class="upload-input" type="file" accept=".jpg, .jpeg, .png"
    [readonly]="isReadOnly$ | async" />
</div>

<div *ngIf="isAudio == 'true'" class="input-container">
  <label class="input-label">{{ placeholder }}</label>
  <input (change)="onInputChange($event)" class="upload-input" type="file" accept=".mp3, .wav, .m4a, .mpeg"
    [readonly]="isReadOnly$ | async" />
</div>

<div *ngIf="isPdf == 'true'" class="input-container">
  <label class="input-label">{{ placeholder }}</label>
  <input (change)="onInputChange($event)" class="upload-input" type="file" [readonly]="isReadOnly$ | async"
    accept=".pdf" />
</div>

<div *ngIf="isSelect == 'true'" class="input-container">
  <label class="input-label">{{ placeholder }}</label>
  <select (change)="onInputChange($event)" class="add-input" [ngModel]="
                 (dropDownValue$ | async) ? (dropDownValue$ | async) : selectedValue
                 " [disabled]="(isReadOnly$ | async) ? true : false">
    <option [value]="" selected></option>
    <option *ngFor="let slokaType of list" [value]="slokaType.id">
      {{ slokaType.title }}
    </option>
  </select>
</div>

<div *ngIf="isSelectSlokasList == 'true'" class="input-container">
  <label class="input-label">{{ placeholder }}</label>
  <select (change)="onInputChange($event)" class="add-input">
    <option value="all" selected>All</option>
    <option *ngFor="let slokaType of list" [value]="slokaType.id">
      {{ slokaType.title }}
    </option>
  </select>
</div>

<div *ngIf="isPriceType && isAdd == 'false'" class="input-container">
  <label class="input-label">{{ placeholder }}</label>
  <select [value]="ticketType" (change)="onInputChange($event)" class="add-input">
    <option value="free">Free</option>
    <option value="paid">Paid</option>
  </select>
</div>

<div *ngIf="isViewImage && !isMultiple" class="input-container">
  <label class="input-label">{{ placeholder }}</label>
  <img [ngStyle]="{ padding: '1.5rem' }" [src]="imageLink" />
</div>

<div *ngIf="isViewImage && isMultiple" class="input-container">
  <label class="input-label">{{ placeholder }}</label>
  <div class="images-list">
    <div *ngFor="let image of imageLink">
      <img [ngStyle]="{ padding: '1.5rem', width: '20rem' }" [src]="image" />
      <div *ngIf="isEdit && isMultiple" (click)="onDeleteImageClick(image)">
        <ng-container *ngTemplateOutlet="deleteIcon"></ng-container>
      </div>
    </div>
  </div>
</div>

<div style="display: flex;" *ngIf="isStartDate && isAdd == 'false'" class="input-container">
  <label class="input-label">{{ placeholder }}</label>
  <div style="padding: 1rem" class="input-container"> 
    <label class="input-label">Date</label>
    <input [ngModel]="startDate" (change)="onStartDate($event)" class="add-input" type="date"
      [readonly]="isReadOnly$ | async" [ngStyle]="{ cursor: isView ? 'context-menu' : 'auto' }" />
  </div>
  <div style="padding: 1rem" class="input-container">
    <label class="input-label">Time</label>
    <input [ngModel]="startTime" (change)="onStartTime($event)" class="add-input" type="time"
      [readonly]="isReadOnly$ | async" [ngStyle]="{ cursor: isView ? 'context-menu' : 'auto' }" />
  </div>
</div>

<div style="display: flex;" *ngIf="isEndDate && isAdd == 'false'" class="input-container">
  <label class="input-label">{{ placeholder }}</label>
  <div style="padding: 1rem" class="input-container"> 
    <label class="input-label">Date</label>
    <input [ngModel]="endDate" (change)="onEndDate($event)" class="add-input" type="date"
      [readonly]="isReadOnly$ | async" [ngStyle]="{ cursor: isView ? 'context-menu' : 'auto' }" />
  </div>
  <div style="padding: 1rem" class="input-container">
    <label class="input-label">Time</label>
    <input [ngModel]="endTime" (change)="onEndTime($event)" class="add-input" type="time"
      [readonly]="isReadOnly$ | async" [ngStyle]="{ cursor: isView ? 'context-menu' : 'auto' }" />
  </div>
</div>

<ng-template #deleteIcon>
  <svg viewBox="0 0 24 24" class="delete-icon">
    <path
      d="m18.5 24h-13c-1.379 0-2.5-1.122-2.5-2.5v-14c0-.276.224-.5.5-.5h17c.276 0 .5.224.5.5v14c0 1.378-1.121 2.5-2.5 2.5zm-14.5-16v13.5c0 .827.673 1.5 1.5 1.5h13c.827 0 1.5-.673 1.5-1.5v-13.5z" />
    <path
      d="m22.5 8h-21c-.276 0-.5-.224-.5-.5v-2c0-1.378 1.121-2.5 2.5-2.5h17c1.379 0 2.5 1.122 2.5 2.5v2c0 .276-.224.5-.5.5zm-20.5-1h20v-1.5c0-.827-.673-1.5-1.5-1.5h-17c-.827 0-1.5.673-1.5 1.5z" />
    <path
      d="m15.5 4h-7c-.276 0-.5-.224-.5-.5v-2c0-.827.673-1.5 1.5-1.5h5c.827 0 1.5.673 1.5 1.5v2c0 .276-.224.5-.5.5zm-6.5-1h6v-1.5c0-.276-.225-.5-.5-.5h-5c-.275 0-.5.224-.5.5z" />
    <path d="m7.5 20c-.276 0-.5-.224-.5-.5v-8c0-.276.224-.5.5-.5s.5.224.5.5v8c0 .276-.224.5-.5.5z" />
    <path d="m12 20c-.276 0-.5-.224-.5-.5v-8c0-.276.224-.5.5-.5s.5.224.5.5v8c0 .276-.224.5-.5.5z" />
    <path d="m16.5 20c-.276 0-.5-.224-.5-.5v-8c0-.276.224-.5.5-.5s.5.224.5.5v8c0 .276-.224.5-.5.5z" />
  </svg>
</ng-template>